"use client";

import { useState } from "react";

import { type Breakpoint, useBreakpointListener } from "../useBreakpointListener/useBreakpointListener";

export type { Breakpoint };

/**
 * Hook that tracks whether the current viewport is at or above a specified breakpoint.
 * Built on top of `useBreakpointListener` — use that hook directly when you need to react
 * imperatively to breakpoint changes rather than hold them as state.
 *
 * @param breakpoint The minimum breakpoint to check against ('sm', 'md', 'lg', 'xl', '2xl')
 * @returns Boolean indicating if the current viewport is at or above the breakpoint, or undefined during SSR
 */
export const useBreakpoint = (breakpoint: Breakpoint): boolean | undefined => {
  const [matches, setMatches] = useState<boolean>();

  useBreakpointListener(breakpoint, setMatches);

  return matches;
};
